<template>
  <div>
    <div class="sp-search-box">
      <div class="sp-title px-4 py-2">
        {{lg('',{
          en: 'Search...',
          zh: '',
        })}}
      </div>
      <div class="sp-main px-4 py-3">
        <div class="row">
          <div class="col col-md-4">
            <div class="sp-tag my-3">
              {{lg('',{
                en: 'TYPE',
                zh: '',
              })}}
            </div>
            <!-- type -->
            <div>
              <span class="sp-option">
                {{lg('',{
                  en: 'Basic',
                  zh: '',
                })}}
              </span>
              <span class="sp-option">
                {{lg('',{
                  en: 'Movies',
                  zh: '',
                })}}
              </span>
              <span class="sp-option">
                {{lg('',{
                  en: 'Holidays',
                  zh: '',
                })}}
              </span>
              <span class="sp-option">
                {{lg('',{
                  en: 'Special',
                  zh: '',
                })}}
              </span>
            </div>
          </div>
          <div class="col col-md-8">
            <div class="sp-tag my-3">
              {{lg('',{
                en: 'TAGS',
                zh: '',
              })}}
            </div>
            
            <div class="row">
              <div class="col-6">
                <div class="sp-tag small mb-3">
                  {{lg('',{
                    en: 'Colour',
                    zh: '',
                  })}}
                </div>

                <div>
                  <span class="sp-option">
                    {{lg('',{
                      en: 'Fur',
                      zh: '',
                    })}}
                  </span>
                  <span class="sp-option">
                    {{lg('',{
                      en: 'Eyes',
                      zh: '',
                    })}}
                  </span>
                  <span class="sp-option">
                    {{lg('',{
                      en: 'Tail',
                      zh: '',
                    })}}
                  </span>
                  <span class="sp-option">
                    {{lg('',{
                      en: 'Hair',
                      zh: '',
                    })}}
                  </span>
                </div>

              </div>
              <div class="col-6">
                <div class="sp-tag small mb-3">
                  {{lg('',{
                    en: 'Special',
                    zh: '',
                  })}}
                </div>
                
                <div>
                  <span class="sp-option">
                    {{lg('',{
                      en: 'Background',
                      zh: '',
                    })}}
                  </span>
                  <span class="sp-option">
                    {{lg('',{
                      en: 'Occessory',
                      zh: '',
                    })}}
                  </span>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="d-flex mt-3">
      <div>
        <label class="mr-3 mb-0">
          <input type="radio">
          <span>
            {{lg('',{
              en: 'For sale',
              zh: '',
            })}}
          </span>
        </label>
        <label class="mr-3 mb-0">
          <input type="radio">
          <span>
            {{lg('',{
              en: 'Other',
              zh: '',
            })}}
          </span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'searchbox',
  components: {},
  props: [],
  data() {
    return {
      
    }
  },
  computed: {},
  watch: {},
  methods: {
    
  },
  created() {
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/vars.scss';

  .sp-search-box{

    border: 3px solid $c;
    border-top: none;

    .sp-title{
      color: #fff;
      background-color: $c;
    }

    .sp-tag{
      color: #fff;
      background-color: $c;
      text-align: center;
      font-weight: bold;
      padding: 5px 0;
      border-radius: 20px;
      
      &.small{
        padding: 3px 0;
        opacity: 0.8;
      }
    }

    .sp-option{
      background-color: mix(#fff,$c,60);
      color: #333;
      margin-bottom: 15px;
      display: inline-block;
      width: 45%;
      margin-left: 2.5%;
      margin-right: 2.5%;
      border-radius: 20px;
      text-align: center;

      cursor: pointer;
    }
  }
</style>